export type InterruptPriority = 0 | 1 | 2 | 3;

export interface InterruptRequest {
  vector: number;
  priority: InterruptPriority;
  source: string;
}

export interface InterruptSnapshot {
  pending: InterruptRequest[];
  masked: boolean;
}

export class InterruptController {
  private pending: InterruptRequest[] = [];
  private masked: boolean = true;

  constructor() {}

  requestInterrupt(request: InterruptRequest): void {
    this.pending.push(request);
  }

  clearInterrupt(vector: number): void {
    this.pending = this.pending.filter(irq => irq.vector !== vector);
  }

  getPendingInterrupt(): InterruptRequest | null {
    if (this.masked || this.pending.length === 0) return null;
    let highest = this.pending[0];
    for (const irq of this.pending) {
      if (irq.priority < highest.priority) highest = irq;
    }
    return highest;
  }

  acceptInterrupt(request: InterruptRequest): void {
    this.pending = this.pending.filter(
      irq => irq.vector !== request.vector || irq.priority !== request.priority
    );
  }

  setMasked(masked: boolean): void {
    this.masked = masked;
  }

  isMasked(): boolean {
    return this.masked;
  }

  clear(): void {
    this.pending = [];
    this.masked = true;
  }

  saveSnapshot(): InterruptSnapshot {
    return { pending: [...this.pending], masked: this.masked };
  }

  loadSnapshot(snapshot: InterruptSnapshot): void {
    this.pending = [...snapshot.pending];
    this.masked = snapshot.masked;
  }
}
